import { CotationFormData } from "@/types/forms/home/cotationFormData.form";
import { CotationsPageComponent } from "./component/CotationsPageComponent";
import { useNavigate, useParams } from "react-router-dom";
import { useGetCustomsV1 } from "@/api/customs.api";
import { useGetPreference } from "@/api/preference.api";
import { useGetOneExpedition, useUpdatePendingQuotation } from "@/api/expedition.api";
import { Loader2 } from "lucide-react";
import { UpdatePendingQuotationDto } from "@/types/api/api-types";
import { updatePendingQuotationPayload } from "./component/UpdatePendingQuotationPayload";

export const CotationsIdPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data: customs, isPending: fetchingCustoms } = useGetCustomsV1();
  const { data: preference, isPending: fetchingPreference } = useGetPreference();

  const { mutateAsync: updatePendingQuotation, isPending: isUpdatingPendingQuotation } =
    useUpdatePendingQuotation();
  const {
    data: expedition,
    isPending: fetchingExpedition,
    isSuccess: fetchedExpedition,
  } = useGetOneExpedition(id || "");

  const onSubmit = async (data: CotationFormData) => {
    if (!id || !expedition?.quotation) {
      console.error("Expedition ID not defined or quotation not found");
      return;
    }

    const payload: UpdatePendingQuotationDto = updatePendingQuotationPayload(expedition, data);

    const ret = await updatePendingQuotation({
      id: id,
      payload,
    });
    if (ret.status === 200) {
      navigate("/pending-shipments");
    }
  };

  if (fetchingExpedition || fetchingCustoms || fetchingPreference) {
    return (
      <div className="flex h-full w-full items-center justify-center">
        <Loader2 className="h-10 w-10 animate-spin" />
      </div>
    );
  }

  if (!fetchedExpedition || !preference || !customs) return <div>Erreur lors du chargement.</div>;

  return (
    <CotationsPageComponent
      handleSubmit={onSubmit}
      initValues={expedition}
      preference={preference}
      isPending={isUpdatingPendingQuotation}
      customs={customs}
    />
  );
};
